import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

import {
  CoachingMethodObject,
  CoachingSessionInput,
  CoachingTacticObject,
  DurationOptionsObject,
  PreparationTimeOptionsObject,
} from '../../../api/CoachingForm/schema';
import { COACHING_TEXT_LIMIT } from '../../../Util';

const validationSchema = (intl: IntlShape): Yup.ObjectSchema =>
  Yup.object<CoachingSessionInput>().shape({
    managerNotes: Yup.string().max(COACHING_TEXT_LIMIT, '-'),
    coachingTactic: Yup.string()
      .nullable()
      .oneOf(
        Object.values(CoachingTacticObject),
        intl.formatMessage({
          id: 'cs_perfportal_coaching_session_validate_required_tactic',
          defaultMessage: 'Please choose a tactic from the dropdown',
        })
      ),
    coachingMethod: Yup.string()
      .nullable()
      .oneOf(
        Object.values(CoachingMethodObject),
        intl.formatMessage({
          id: 'cs_perfportal_coaching_session_validate_required_method',
          defaultMessage: 'Please choose a method from the dropdown',
        })
      ),
    duration: Yup.string()
      .nullable()
      .oneOf(
        Object.values(DurationOptionsObject),
        intl.formatMessage({
          id: 'cs_perfportal_coaching_session_validate_required_duration',
          defaultMessage: 'Please choose a duration from the dropdown',
        })
      ),
    preparationTime: Yup.string()
      .nullable()
      .oneOf(
        Object.values(PreparationTimeOptionsObject),
        intl.formatMessage({
          id: 'cs_perfportal_coaching_session_validate_required_preparation',
          defaultMessage: 'Please choose a preparation time from the dropdown',
        })
      ),
    coachingSummaryNotes: Yup.string().max(COACHING_TEXT_LIMIT, '-'),
  });

export default validationSchema;
